<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components:{commona},
  data(){
    return {
      config:{
        title:'保险费用',
        urlKey:'/insur',
        formId:'baoxian',
        item: {
        carId: 0,
        carNo: "",
        insurCost: 0,
        insurDate: Date.now(),
        cardNo: "",
        mileage: 0,
        proofList: [],
        insurStation: "",
        insurVolume: 0,
        remainVolume: 0,
        remark: "",
        type: "",
        unitPrice: 0,
      },
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/carInsur.vue